module.exports = __webpack_public_path__ + "img/jhsdk.23816707.png";